// Multi-select dropdown for assigning a property to matching Areas.
//
// Reads its options and initial selection from data attributes on the root
// element (data-areas / data-selected) so apostrophes in area names can't
// break an x-data expression. Maintains `selected` as the source of truth;
// the template renders a hidden `property[area_ids][]` input per selected id
// so the selection submits with the surrounding Rails form.
export const areaMultiselect = () => ({
  open: false,
  areas: [],
  selected: [],

  init() {
    try {
      this.areas = JSON.parse(this.$el.dataset.areas || "[]");
      this.selected = JSON.parse(this.$el.dataset.selected || "[]").map(Number);
    } catch (e) {
      this.areas = [];
      this.selected = [];
    }
  },

  toggle(id) {
    id = Number(id);
    const i = this.selected.indexOf(id);
    if (i === -1) this.selected.push(id);
    else this.selected.splice(i, 1);
  },

  isSelected(id) {
    return this.selected.includes(Number(id));
  },

  nameFor(id) {
    const area = this.areas.find((a) => a.id === Number(id));
    return area ? area.name : "";
  },
});
